"use strict";
import React from "react";

const getInLineLoader = function () {
    return <div style={{ display: 'inline' }}><div className="box"><div className="loader-01"></div></div></div>;
}
const getLoader = function () {
    return <div className="box flexLoader"><div className="loader-01" /></div>;
}
const getFullScreenLoader = function () {
    return <div className="fullScreenLoader modalComponent  fade modal" role="dialog" tabIndex="-1" ><div className="box"><div className="loader-01"></div></div></div>;
}

module.exports = {
    getInLineLoader,
    getLoader,
    getFullScreenLoader,
    fullScreenLoader: getFullScreenLoader(),
    loader: getLoader(),
    inLineLoader: getInLineLoader()
}